import { render, staticRenderFns } from "./ProposalEditor.vue?vue&type=template&id=6a42abba&scoped=true"
import script from "./ProposalEditor.vue?vue&type=script&lang=ts"
export * from "./ProposalEditor.vue?vue&type=script&lang=ts"
import style0 from "./ProposalEditor.vue?vue&type=style&index=0&id=6a42abba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a42abba",
  null
  
)

export default component.exports